import React, { useState, useEffect, useRef } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import Accordion from './Accordion';
import Gallery from './Gallery';

const slides = [
    {
      endValue: 13000000,
      title: 'Οι δεσμεύσεις μας για να προστατεύσουμε το περιβάλλον',
      content: '',
    },
    {
      endValue: 10000000,
      title: 'για την αντιμετώπιση της ρύπανσης από πλαστικά (5χρόνια)',
      content: 'Η σημαντικότερη δέσμευσή μας αφορά την αντιμετώπιση της μεγαλύτερης περιβαλλοντικής πρόκλησης της εποχής μας: της ρύπανσης από πλαστικά. Αιχμή του δόρατος σε αυτήν την προσπάθεια θα συνεχίσει να είναι το “Typhoon Project”. Με δράσεις στο πεδίο, παράκτιους και υποθαλάσσιους καθαρισμούς, εποικοδομητικές συνεργασίες με φορείς και οργανώσεις του χώρου, εκπαιδευτικά προγράμματα, καθώς και με ακαδημαϊκές έρευνες θα συμβάλουμε ακόμη περισσότερο στην προστασία του θαλάσσιου περιβάλλοντος, στην πρόληψη και στην αποφυγή της θαλάσσιας ρύπανσης.',
    },
    {
      endValue: 1500000,
      title: 'για την αντιμετώπιση της ρύπανσης στο Σαρωνικό Κόλπο (3 χρόνια)',
      content: 'Γνωρίζατε πως ο Βόρειος Σαρωνικός αποτελεί μία από τις πιο υποβαθμισμένες θαλάσσιες περιοχές της Ελλάδας; Με την «υιοθέτηση» του Σαρωνικού Κόλπου, ως «εθνικής πειραματικής περιοχής», θα διερευνήσουμε διεξοδικά το ανθρωπογενές αποτύπωμα με επιστημονικές μελέτες της χημικής ρύπανσης, των απορριμμάτων και της υποβάθμισης της βιοποικιλότητας. Το εκτενές αρχείο δεδομένων που θα δημιουργηθεί, θα βοηθήσει στον σχεδιασμό πολιτικών και στρατηγικών για την αποκατάσταση του περιβάλλοντος του Σαρωνικού, όπου τα τελευταία 50 χρόνια η ρύπανση έχει αυξηθεί δραματικά.',
    },
    {
      endValue: 1500000,
      title: 'για τη συνέχιση του προγράμματος «Fishing for Litter» (5 χρόνια)',
      content: 'Με τη συμβολή της αλιευτικής κοινότητας, συνεχίζουμε το πρόγραμμα “Fishing For Litter”, με στόχο τον καθαρισμό και τη προστασία του βυθού. Το πρόγραμμα «Fishing For Litter» υλοποιείται από το Κοινωφελές Ίδρυμα Αθανάσιος Κ. Λασκαρίδης σε συνεργασία με τη περιβαλλοντική οργάνωση iSea. Οι συμμετέχοντες αλιείς τράτας δεσμεύονται για την συλλογή και την καταγραφή των απορριμμάτων που συγκεντρώνονται στα δίχτυα τους στη διάρκεια της συνηθισμένης τους αλιευτικής δραστηριότητας. Τα απορρίμματα που συλλέγουν αναλύονται από την επιστημονική ομάδα του προγράμματος και οδηγούνται σε ενδεδειγμένους τρόπους διαχείρισης. Από το 2018 έως το 2023, στο πρόγραμμα συμμετέχουν 143 αλιευτικά σκάφη σε 13 λιμάνια της χώρας.',
    },
    {
      title: 'Υποστήριξη του προγράμματος εποπτείας των θαλάσσιων προστατευόμενων περιοχών από την Ελληνική Κυβέρνηση και το Global Fishing Watch (2 χρόνια)',
      content: 'Η τεχνολογία συμβάλλει σημαντικά στην περιβαλλοντική προστασία. Η Ελληνική Κυβέρνηση και ο διεθνώς αναγνωρισμένος μη κερδοσκοπικός οργανισμός “ Global Fishing Watch ” ξεκινούν ένα πρόγραμμα εποπτείας των θαλάσσιων προστατευόμενων περιοχών μέσω σύγχρονων τεχνολογιών και εμείς δεσμευτήκαμε για την οικονομική υποστήριξη της δράσης και τη συμβολή μας στην υλοποίησή της.',
    },
  ];

  const CountUpComponent = ({ end }) => {
    const { ref, inView } = useInView({
      triggerOnce: true,
      threshold: 0.5,
    });
  
    return (
      <span ref={ref}>
        {inView ? <CountUp end={end} duration={3} separator="." suffix="€" /> : "0€"}
      </span>
    );
  };

  const Commitments = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupContentType, setPopupContentType] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const sliderRef = useRef(null);
  
    const handlePopupOpen = (type) => {
      setPopupContentType(type);
      setIsPopupOpen(true);
    };
  
    const handlePopupClose = () => {
      setIsPopupOpen(false);
      setPopupContentType('');
    };
  
    const handleScroll = (e) => {
      if (isDragging) return;
    
      const sliderRect = sliderRef.current.getBoundingClientRect();
      const isCentered = sliderRect.top >= 0 && sliderRect.bottom <= window.innerHeight;
    
      if (isCentered) {
        if (currentIndex === 0) {
          // On the first slide: allow upward scroll, change slide on downward scroll
          if (e.deltaY > 0) {
            e.preventDefault(); // Prevent default downward scroll to change slides
            setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, slides.length - 1));
          }
          // Allow normal upward scrolling without preventing default scroll
        } else if (currentIndex === slides.length - 1) {
          // On the last slide: allow downward scroll, prevent upward scroll to change slides
          if (e.deltaY < 0) {
            e.preventDefault();
            setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
          }
        } else {
          // On other slides: prevent default scroll and change slide in both directions
          e.preventDefault();
          if (e.deltaY > 0) {
            setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, slides.length - 1));
          } else if (e.deltaY < 0) {
            setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
          }
        }
      }
    };
    
    useEffect(() => {
      const handleScrollEvent = (e) => {
        handleScroll(e);
      };
    
      const sliderElement = sliderRef.current;
    
      const checkIfSliderIsCentered = () => {
        const sliderRect = sliderElement.getBoundingClientRect();
        const isCentered = sliderRect.top >= 0 && sliderRect.bottom <= window.innerHeight;
    
        // Apply overflow: hidden only for slides other than the first
        if (isCentered && currentIndex !== 0 && currentIndex !== slides.length - 1) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = ''; // Allow default scrolling on the first and last slides
        }
      };
    
      if (sliderElement) {
        sliderElement.addEventListener('wheel', handleScrollEvent, { passive: false });
      }
    
      checkIfSliderIsCentered();
      window.addEventListener('resize', checkIfSliderIsCentered);
      window.addEventListener('scroll', checkIfSliderIsCentered);
    
      return () => {
        if (sliderElement) {
          sliderElement.removeEventListener('wheel', handleScrollEvent);
        }
        window.removeEventListener('resize', checkIfSliderIsCentered);
        window.removeEventListener('scroll', checkIfSliderIsCentered);
        document.body.style.overflow = '';
      };
    }, [currentIndex, isDragging, slides.length]);
    
    
  
    const handleTouchStart = (e) => {
      setStartX(e.touches[0].clientX);
      setIsDragging(true);
    };
  
    const handleTouchMove = (e) => {
      if (!isDragging) return;
  
      const moveX = e.touches[0].clientX - startX;
  
      if (moveX > 100) {
        
        if (currentIndex > 0) {
          setCurrentIndex(prevIndex => Math.max(prevIndex - 1, 0));
          setStartX(e.touches[0].clientX); 
        }
      } else if (moveX < -100) {
       
        if (currentIndex < slides.length - 1) {
          setCurrentIndex(prevIndex => Math.min(prevIndex + 1, slides.length - 1));
          setStartX(e.touches[0].clientX); 
        }
      }
    };
  
    const handleTouchEnd = () => {
      setIsDragging(false);
    };
  
    const handleMouseDown = (e) => {
      setStartX(e.clientX);
      setIsDragging(true);
    };
  
    const handleMouseMove = (e) => {
      if (!isDragging) return;
  
      const moveX = e.clientX - startX;
  
      if (moveX > 100) {
        
        if (currentIndex > 0) {
          setCurrentIndex(prevIndex => Math.max(prevIndex - 1, 0));
          setStartX(e.clientX);
        }
      } else if (moveX < -100) {
        
        if (currentIndex < slides.length - 1) {
          setCurrentIndex(prevIndex => Math.min(prevIndex + 1, slides.length - 1));
          setStartX(e.clientX); 
        }
      }
    };
  
    const handleMouseUp = () => {
      setIsDragging(false);
    };
  
    const handlePaginationClick = (index) => {
  
      setCurrentIndex(index);
    };
    
    useEffect(() => {
      const acc = document.getElementsByClassName('accordion');
      if (acc.length > 0) {
        acc[0].classList.add('active');
        const firstPanel = acc[0].nextElementSibling;
        firstPanel.style.maxHeight = firstPanel.scrollHeight + 134 + 'px';
      }
  
      for (let i = 0; i < acc.length; i++) {
        acc[i].addEventListener('click', function() {
          for (let j = 0; j < acc.length; j++) {
            if (j !== i) {
              acc[j].classList.remove('active');
              const otherPanel = acc[j].nextElementSibling;
              otherPanel.style.maxHeight = null;
              otherPanel.style.padding = null;
            }
          }
  
          this.classList.toggle('active');
          const panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
            panel.style.padding = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + 134 + 'px';
          }
        });
      }
    }, []);

    return (
        <section className="s-sec">
          <div className="background__">
            <img src="img/vertical-aerial-shot-sea-waves-hitting-cliff.jpg" alt="Sea Waves" />
            <div className="background__grad"></div>
          </div>
          <div className="commit-wrapper">
            <h4>Οι Δεσμεύσεις μας</h4>
            <div
            className="slider-container comSlider"
            ref={sliderRef}
            onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
          >
            <div
              className="slides-wrapper"
              style={{
                transform: `translateX(-${currentIndex * 100}%)`,
              }}
            >
              {slides.map((slide, index) => (
                <div
                  key={index}
                  className={`slide ${index === currentIndex ? 'active' : ''}`}
                >
                  {slide.endValue && <CountUpComponent end={slide.endValue} />}
                  <h5>{slide.title}</h5>
                  <p>{slide.content}</p>
                </div>
              ))}
            </div>
            <div className="pagination">
              {slides.map((_, index) => (
                <span
                  key={index}
                  className={`pagination-dot ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => handlePaginationClick(index)}
                ></span>
              ))}
            </div>
          </div>
          </div>
          <div className="part-wrapper">
            <div className="title-wrapper">
              <h2>Οι συμμετοχές μας στο 9ο Our Ocean Conference</h2>
            </div>
              <Accordion title="Side Event: Technology for Good: How Innovation and Open Data Can Deliver Ocean Action" index="1">
                <div className="flex">
                  <div className="panel-left">
                    <p>Η θεματική συζήτηση “Technology for Good: How Innovation and Open Data Can Deliver Ocean Action” υπογράμμισε τη σημασία της τεχνολογίας στην προστασία των ωκεανών και τον καθοριστικό ρόλο της στην αντιμετώπιση των προκλήσεων, καθώς και στην αναζήτηση νέων λύσεων.</p>
                    <p>Με έμφαση στη διαχείριση της αλιευτικής δραστηριότητας και την ανάγκη πρόσβασης σε ανοιχτά δεδομένα, το Ελληνικό Κράτος και ο διεθνώς αναγνωρισμένος μη κερδοσκοπικός οργανισμός “Global Fishing Watch” ανακοίνωσαν το κοινό πρόγραμμα εποπτείας θαλάσσιων προστατευόμενων περιοχών μέσω σύγχρονων τεχνολογιών. Το Κοινωφελές Ίδρυμα Αθανάσιος Κ. Λασκαρίδης θα συμβάλει στην υλοποίηση του προγράμματος και θα υποστηρίξει οικονομικά τη συνεργασία.</p>
                    <ul> Ομιλητές:
                      <li><strong>Tony Long</strong>, CEO of Global Fishing Watch</li>
                      <li><strong>Rocio Parra Cortes</strong>, Head of the Legal Division, Undersecretariat of Fisheries and Aquaculture of Chile</li>
                      <li><strong>Jose Julios Casas</strong>, Technical Secretary, Corredor Marino del Pacifico Este Tropical (CMAR)</li>
                      <li><strong>Dr. Khallahi Brahim</strong>, Permanent Secretary, Sub-Regional Fisheries Commission</li>
                      <li><strong>Δρ. Πέτρος Βαρελίδης</strong>, Γενικός Γραμματέας του Υπουργείου Περιβάλλοντος και Ενέργειας</li>
                      <li><strong>Εύη Λαζού- Λασκαρίδη</strong>, Πρόεδρος Κοινωφελούς Ιδρύματος Αθανάσιος Κ. Λασκαρίδης</li>
                    </ul>
                  </div>
                  <div className="panel-right">
                    <img src="img/SIDEEVENT-15APRIL/IMG_0344.jpg" alt="Side Event" />
                    <span className="popup-trigger" onClick={() => handlePopupOpen('gallery')}>ΦΩΤΟΓΡΑΦΙΕΣ</span>
                  </div>
                </div>
              </Accordion>
              <Accordion title="Plenary Session II: Confronting Plastic Pollution" index="2">
                <div className="flex">
                  <div className="panel-left">
                    <p>Στο επίκεντρο του 9 ου Our Ocean Conference ήταν τα Plenary Sessions, τα οποία φιλοξένησαν τα commitments εκπροσώπων χωρών, οργανώσεων και επιχειρήσεων από όλο τον κόσμο, ανοίγοντας το δρόμο σε νέες πρωτοβουλίες και δράσεις για την προστασία των ωκεανών.</p>
                    <p>Στο Plenary Session II: Confronting Plastic Pollution, η Πρόεδρος του Ιδρύματος, Εύη Λαζού-Λασκαρίδη ανακοίνωσε τη μεγαλύτερη από τις δεσμεύσεις του Ιδρύματος, ύψους 10.000.000 ευρώ.</p>
                  </div>
                  <div className="panel-right">
                    <img src="img/screenshot2.png" alt="Side Event" />
                    <span className="popup-trigger" onClick={() => handlePopupOpen('video')}>ΒΙΝΤΕΟ</span>
                  </div>
                </div>
              </Accordion>
              <Accordion title="Side Event: Marine Pollution: Bridging Science and Policymaking" index="3">
                <div className="flex">
                  <div className="panel-left">
                    <p>Τα θαλάσσια απορρίμματα επιβαρύνουν το περιβάλλον και υποβαθμίζουν την υγεία των οικοσυστημάτων. Η προστασία του θαλάσσιου περιβάλλοντος είναι πιο επίκαιρη και αναγκαία από ποτέ. Στη συζήτηση “Marine Pollution: Bridging Science and Policymaking” μιλήσαν διακεκριμένοι καλεσμένοι για την αναγνώριση της σύνδεσής μας με τη θάλασσα, την κατανόηση του μεγέθους του προβλήματος, τη σύναψη αποτελεσματικών συνεργασιών, καθώς και τη συστηματική συλλογή επιστημονικών δεδομένων ως αναγκαία βήματα για τη διατήρηση της υγείας του πλανήτη.</p>
                    <p>Ο Παναγιώτατος Οικουμενικός Πατριάρχης κ.κ. Βαρθολομαίος ευλόγησε το έργο του Ιδρύματος και μας ενέπνευσε με τον λόγο του.</p>
                    <ul> Speakers:
                      <li><strong>Αυτού Θειοτάτη Παναγιότης</strong>, Αρχιεπίσκοπος Κωνσταντινουπόλεως, Νέας Ρώμης και Οικουμενικός Πατριάρχης Βαρθολομαίος</li>
                      <li><strong>Εύη Λαζού- Λασκαρίδη</strong>, Πρόεδρος Κοινωφελούς Ιδρύματος Αθανάσιος Κ. Λασκαρίδης</li>
                      <li><strong>Μαρία Δαμανάκη</strong>,Σύμβουλος για το Κλίμα και τη Θαλάσσια Πολιτική και πρώην Επίτροπος Θαλάσσιας Πολιτικής και Αλιείας της ΕΕ,</li>
                      <li><strong>Γιώργος Παπαθεοδώρου</strong>, Καθηγητής Γεωλογικής και των Θετικών Επιστημών του Πανεπιστημίου Πατρών</li>
                      <li><strong>Cyrill Gutsch</strong>, CEO/Founder, Parley for the Oceans</li>
                      <li><strong>Maxine Burkett</strong>, Assistant Director for Climate Ocean and Equity, White House Office of Science & Technology Policy, CEO of Global Fishing Watch </li>
                    </ul>
                  </div>
                  <div className="panel-right">
                    <img src="img/SIDEEVENT-17 APRIL(1)/gxg_1309_53662440108_o.jpg" alt="Side Event" />
                    <span className="popup-trigger" onClick={() => handlePopupOpen('both')}>ΦΩΤΟΓΡΑΦΙΕΣ & ΒΙΝΤΕΟ</span>
                  </div>
                </div>
              </Accordion>
              <Accordion title="Waves of Cinema: A Festival of Oceanic Films – Fishing For Litter Documentary" index="4">
                <div className="flex">
                  <div className="panel-left">
                    <p>Το ντοκιμαντέρ “Fishing For Litter”, μια συνεργασία του Σωτήρη Δανέζη και του Κοινωφελούς Ιδρύματος Αθανάσιος Κ. Λασκαρίδης, προβλήθηκε στο “Our Ocean Film Festival”, στη διάρκεια του τριήμερου συνεδρίου «Our Ocean Conference”.</p>
                    <p>To ντοκιμαντέρ “Fishing For Litter” εμβαθύνει στις ζωές τεσσάρων έμπειρων αλιέων, υφαίνοντας μια συγκλονιστική ιστορία αλλαγής που παρατηρήθηκε στα χρόνια δραστηριότητάς τους στο Αιγαίο. Το ντοκιμαντέρ δεν είναι μια απλή αφήγηση της θαλάσσιας ρύπανσης από πλαστικό, αλλά προβάλλει τις εμπειρίες πρώτης γραμμής αυτών των ψαράδων και την πρωτοποριακή πρωτοβουλία του προγράμματος “Fishing For Litter”.</p>
                  </div>
                  <div className="panel-right">
                    <img src="img/screenshot3.png"></img>
                    <span className="popup-trigger" onClick={() => handlePopupOpen('video-large')}>ΒΙΝΤΕΟ ΝΤΟΚΙΜΑΝΤΕΡ</span>
                  </div>
                </div>
              </Accordion>
              <Gallery isOpen={isPopupOpen} contentType={popupContentType} onClose={handlePopupClose} />
          </div>
        </section>
      );
    };
    
    export default Commitments;
    